import type { Alert } from '@/types'

export function formatOIThreshold(alert: Pick<Alert, 'oi_threshold_unit' | 'oi_threshold_value' | 'oi_threshold_pct'>): string {
  const unit = alert.oi_threshold_unit || 'percent'
  const value = alert.oi_threshold_value ?? (unit === 'percent' ? alert.oi_threshold_pct : undefined)
  if (value === undefined) return 'Not configured'
  const formatted = value.toLocaleString('en-US', { maximumSignificantDigits: 12 })
  return unit === 'percent' ? `${formatted}%` : `${formatted} ${unit === 'usdt' ? 'USDT' : 'coins'}`
}
